<template>
  <div class="d-group text-dark">
    <label class="d-label">Temavisning</label>
    <div class="choose-subject">
      <div class="choose-subject__spinner" v-if="isLoadingSubjects">
        <div class="do-spinner"></div>
      </div>
      <dSelect :items="sortedSubjects" v-else
               :receiveData="theNewSubject"
               :multiple="false"
               :placeholder="$t('vue2.create_activity.search_or_create')"
               :itemSpaceBetween="true"
               @enter="onCreateNewSubject"
               @update="setSubject"
               @searchText="setTheSearchText"
               @onSearchTextDebounced="onSearchTextDebounced"
               @close="onCloseDSelect">
        <template v-for="(item, index) in sortedSubjects" v-slot:test="slotProps">
          <div class="choose-subject__event_type">
            {{ slotProps.item.vSubjectType }}
          </div>
        </template>
        <div slot="noMatch">
          <h4 class="create-subject-link"
              @click="onCreateNewSubject">
            + {{ $t('vue2.substitution.create') }}: "{{ theSearchText }}"
          </h4>
        </div>
      </dSelect>
      <div class="icon__bg-circle create-new-subject"
           v-if="isShowCreateSubjectButton"
           v-tippy="{
                arrow: true,
                animateFill: false,
                animation : 'shift-away',
                zIndex: '999999992',
                boundary: 'window'
              }"
           :content='$t("vue2.substitution.create") + ` "` + theSearchText + `" `'
           @click="onCreateNewSubject">
        <span class="d-icon-plus"></span>
      </div>
    </div>
  </div>
</template>
<script>
import dSelect from '../../DSelect/DSelect.vue'
import moment from 'moment'
import docendo from '../../../docendo'
import eventbus from '../../../eventbus'

export default {
  components: {dSelect},
  props: {
    calendarId: {
      default: () => null
    },
    date: {
      default: () => moment()
    },
    selectedSubject: {
      default: null
    },
    schoolId: {
      default: null
    }
  },
  data () {
    return {
      isLoadingSubjects: false,
      subjects: [],
      theSearchText: '',
      theNewSubject: null,
      isShowCreateSubjectButton: false,
      isCreatingNewSubject: false,
      subjectType: 'frame',
      theNewlyCreatedSubject: null
    }
  },
  computed: {
    activeSchoolYears () {
      return this.$store.state.activeSchoolYears
    },
    filteredSubjects () {
      return this.subjects.filter(subject => subject.subject_type === this.subjectType)
    },
    sortedSubjects () {
      return this.filteredSubjects
        .map(subject => {
          const translatedSubjectType = this.$t(`vue2.eventTypes.${subject.subject_type}`)
          const vSubjectType = translatedSubjectType === `vue2.eventTypes.${subject.subject_type}`
            ? subject.subject_type
            : translatedSubjectType
          return {
            ...subject,
            vSubjectType
          }
        })
        .sort((a, b) => {
          return a.name.localeCompare(b.name)
        })
    }
  },
  watch: {
    calendarId () {
      this.readSubjects()
    }
  },
  methods: {
    onCloseDSelect () {
      this.isShowCreateSubjectButton = false
    },
    setIsShowCreateSubjectButton () {
      const idx = this.filteredSubjects.findIndex(subject => subject.name === this.theSearchText)
      this.isShowCreateSubjectButton = this.theSearchText.length > 0 && idx < 0
    },
    onSearchTextDebounced () {
      this.setIsShowCreateSubjectButton()
    },
    findSchoolYearId () {
      if (this.activeSchoolYears.length === 1) {
        return this.activeSchoolYears[0].id
      }
      const givenDate = moment(this.date)
      const overlappingSchoolYears = this.activeSchoolYears.filter(year => {
        const start = moment(year.employee_time_start)
        const end = moment(year.employee_time_end)
        return givenDate.isBetween(start, end, undefined, '[]')
      })

      if (overlappingSchoolYears.length > 0) {
        const latestSchoolYear = overlappingSchoolYears.reduce((latest, current) => {
          const latestEnd = moment(latest.employee_time_end)
          const currentEnd = moment(current.employee_time_end)
          return currentEnd.isAfter(latestEnd) ? current : latest
        }, overlappingSchoolYears[0])

        return latestSchoolYear.id
      } else {
        eventbus.toast = {
          text: this.$t('vue2.create_activity.the_selected_date_is_outside_schoolyears'),
          'success': false
        }
        return null
      }
    },
    onCreateNewSubject () {
      const calendarId = this.calendarId
      const schoolYearId = this.findSchoolYearId()
      if (!schoolYearId || !calendarId) {
        return
      }
      const schoolId = this.schoolId
      const color = '#999999'
      const duration = 300
      const preparation = null
      const calendarIds = []
      const subjectCode = null
      this.isCreatingNewSubject = true
      docendo.createSubject(this.theSearchText, color, calendarId, duration, preparation, 0, this.subjectType, schoolId, schoolYearId, calendarIds, subjectCode, true, null, null, null, data => {
        if (data && data.status === 'error') {
          eventbus.toast = {text: data.message, 'success': false}
          return
        }
        this.isCreatingNewSubject = false
        this.theNewlyCreatedSubject = data
        this.theSearchText = ''
        this.readSubjects()
      }, failure => {
        console.log('failed')
      })
    },
    setTheSearchText (str) {
      this.theSearchText = str
    },
    setSubject (arr) {
      this.$emit('setSubject', arr[0])
    },
    readSubjects () {
      if (!this.calendarId) {
        return
      }
      this.isLoadingSubjects = true
      docendo.sidebar(this.calendarId, this.date, success => {
        this.isLoadingSubjects = false
        this.subjects = success
        this.$nextTick(_ => {
          if (this.theNewlyCreatedSubject) {
            this.theNewSubject = this.theNewlyCreatedSubject
          }
        })
      }, failure => {
        console.log('something went wrong')
      })
    }
  },
  mounted () {
    this.readSubjects()
  }
}
</script>

<style scoped>
@import "../../../assets/css/variables.css";

.choose-subject__spinner {
  position: relative;
  pointer-events: none;
  cursor: not-allowed;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding-right: 1rem;
  height: 34px;
  width: 100%;
  border-radius: 4px;
  border: 1px solid #edf2f7;
  -webkit-appearance: none !important;
  background: #fff;
  box-shadow: 0 2px 5px -1px rgba(50, 50, 93, .25), 0 1px 3px -1px rgba(0, 0, 0, .3);
}

.choose-subject__spinner:before {
  content: 'Søg eller opret';
  position: absolute;
  top: 0;
  bottom: 0;
  left: 9px;
  line-height: 32px;
  color: #757575;
}

.choose-subject {
  position: relative;
}

.create-new-subject {
  position: absolute;
  top: 0.2rem;
  right: -2.6rem;
}

.d-icon-plus {
  font-size: 13px;
}

.d-icon-plus:before {
  content: '+';
  color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  width: 14px;
  height: 14px;
  background-color: rgb(162, 163, 166);
  opacity: 0.6;
}

.create-subject-link {
  background-color: var(--blue) !important;
  color: white;
  cursor: pointer;
}

.d-group {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  margin-bottom: 1rem;
}
</style>



// WEBPACK FOOTER //
// ClassOnTripSubject.vue?18ba7440